import { render, staticRenderFns } from "./stockForm.vue?vue&type=template&id=710b68b6&"
import script from "./stockForm.vue?vue&type=script&lang=js&"
export * from "./stockForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports